const article = {
  id: 7,
  category: "Transformation digitale",
  title: "Baromètre 2025 : Où en sont les PME dans leur transformation digitale ?",
  text: "80% des PME ont engagé leur digitalisation, mais les défis restent nombreux. Découvrez les tendances et nos solutions pour accélérer votre transition.",
  link: "/articles/transformation-digitale-pme-barometre-2025",
  date: "Septembre 2025",
  highlight: "Cybersécurité, IA, efficacité opérationnelle : les priorités 2026"
};

export default article;
